import React, { useEffect, useState } from 'react';

import { Link, useHistory } from 'react-router-dom';

import {
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  Schema,
  Alert,
} from 'rsuite';

import AuthButtonRow from '../components/AuthButtonRow';
import AuthPanel from '../components/AuthPanel';
import { useAuth } from '../states/AuthState';
import { login } from '../utils/api';

const { StringType } = Schema.Types;

const model = Schema.Model({
  email: StringType()
    .isEmail('Please enter a valid email address.')
    .isRequired('Please enter your email.'),
  password: StringType().isRequired('Please enter your password.'),
});

export default function RegisterPage() {
  const history = useHistory();
  const [formValue, setFormValue] = useState({
    email: '',
    password: '',
  });
  const [form, setFormRef] = useState(null);
  const { setIsAuthed } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setErrorMessage('');
  }, []);

  const handleSubmit = () => {
    if (!form.check()) {
      return;
    }

    login(formValue.email, formValue.password)
      .then((json) => {
        if (json.error) {
          setErrorMessage(json.error);
        } else {
          setIsAuthed(true);
          history.push('/dashboard');
        }
      })
      .catch((err) => {
        Alert.error(err.message);
      });
  };

  useEffect(() => {
    document.title = 'Login | BigBrain';
  }, []);

  const handleCheck = (e) => {
    setErrorMessage(e.password);
  };

  return (
    <AuthPanel header={<h3>Login</h3>}>
      <Form
        fluid
        model={model}
        checkTrigger="blur"
        formValue={formValue}
        onChange={(newValue) => setFormValue(newValue)}
        onSubmit={handleSubmit}
        onCheck={handleCheck}
        ref={(ref) => setFormRef(ref)}
      >
        <FormGroup controlId="email-input">
          <ControlLabel>Email</ControlLabel>
          <FormControl id="email-input" name="email" />
        </FormGroup>
        <FormGroup controlId="password-input">
          <ControlLabel>Password</ControlLabel>
          <FormControl
            id="password-input"
            name="password"
            type="password"
            errorMessage={errorMessage}
          />
        </FormGroup>
        <FormGroup>
          <AuthButtonRow>
            <Button appearance="primary" type="submit">
              Sign in
            </Button>
            <Link to="/dashboard/register">Register here!</Link>
          </AuthButtonRow>
        </FormGroup>
      </Form>
    </AuthPanel>
  );
}
